export default {
  data () {
    return {
    }
  },
  methods: {
    /*
    bg_header: '#ffffff',
        bg_subheader: '#E6E3E0',
        header_icon_color: '#2C2A29',
        font_subheader_color: '#2C2A29',
        icon_labels_bg: '#E6E3E0',
        icon_labels_icon: '#FF6000'
    */
    getCssColor (key, light) {
      if (!light) {
        return this.$store.getters.getColors[key]
      } else if (light === 'light-1'){
        return this.convertToRgbA(this.$store.getters.getColors[key], 1, 50)
      } else if (light === 'light-2'){
        return this.convertToRgbA(this.$store.getters.getColors[key], 1, 125)
      }
    },

    convertToRgbA (color, a, ligthen) {
      let rgba = 'rgba(' + (this.hexToR(color) +ligthen) + ','+ (this.hexToG(color) +ligthen) + ','+ (this.hexToB(color)+ligthen) + ',' + a + ')'
      return rgba
    },

    hexToR(h) {return parseInt((this.cutHex(h)).substring(0,2),16)},
    hexToG(h) {return parseInt((this.cutHex(h)).substring(2,4),16)},
    hexToB(h) {return parseInt((this.cutHex(h)).substring(4,6),16)},
    cutHex(h) {return (h.charAt(0)=="#") ? h.substring(1,7):h},
  }
}